export default __webpack_public_path__ + "e47600389c7ec7ec5fbeb736a80de30b.svg";